import { supabase } from '@/integrations/supabase/client';

/**
 * Dispara la sincronización con Google Calendar en segundo plano.
 * - Fire and forget: nunca bloquea la UI ni muestra toasts.
 * - Agrupa (debounce) los usuarios afectados en una sola llamada.
 */
const DEBOUNCE_MS = 1500;

let pending = new Set<string>();
let timer: ReturnType<typeof setTimeout> | null = null;

async function flush() {
  timer = null;
  const userIds = [...pending];
  pending = new Set();
  if (!userIds.length) return;

  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return;

    const { error } = await supabase.functions.invoke('google-calendar-sync', {
      body: { origin: window.location.origin, user_ids: userIds },
    });
    if (error) throw error;
  } catch (error) {
    console.warn('google-calendar auto-sync:', error);
  }
}

export function triggerCalendarSync(userIds: (string | null | undefined)[]) {
  const ids = userIds.filter((id): id is string => typeof id === 'string' && id.length > 0);
  if (!ids.length) return;
  ids.forEach((id) => pending.add(id));
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => { void flush(); }, DEBOUNCE_MS);
}
